import React from 'react';
import {StyleSheet, View, Text, StyleProp, ViewStyle} from 'react-native';
import {colors} from 'src/assets';
import LocalText from 'src/local';

type Props = {
  style?: StyleProp<ViewStyle>;
  value: number;
};

export const PV: React.FC<Props> = ({style, value}) => {
  return (
    <View style={[styles.container, style]}>
      <Text style={styles.label}>
        {LocalText.components.offerListItem.pv.label}
      </Text>
      <Text style={styles.text}>{value}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  label: {
    fontSize: 12,
    color: colors.chokyGray10,
  },
  text: {
    fontSize: 14,
    fontWeight: 'bold',
    color: colors.chokuGray9,
  },
});
